export default "__VITE_ASSET__DvKgm25___"